import { IssueEventOnView } from 'components/dataProviders/withIssue/model';
import { DocumentOnView } from 'presentation/document/documentOnView';
import { logError } from 'setup/logger/logError';

interface DialogState {
  dialogTitle: string;
  event: IssueEventOnView;
  eventTitle: string;
  eventDescriptionWithMarkup: string;
  /** Changes for every event the dialog is prepared for: the description input starts over. */
  descriptionResetKey: number;
  descriptionError: boolean;
  charCount: number;
  documents: DocumentOnView[];
  nameTouched: boolean;
  datePristine: boolean;
  savingData: boolean;
}

export const dialogInitialState: DialogState = {
  dialogTitle: '',
  event: {} as IssueEventOnView,
  eventTitle: '',
  eventDescriptionWithMarkup: '',
  descriptionResetKey: 0,
  descriptionError: false,
  charCount: 0,
  documents: [] as DocumentOnView[],
  nameTouched: false,
  datePristine: true,
  savingData: false,
};

export const dialogActionTypes = {
  SETUP_NEW_EVENT: 'SETUP_NEW_EVENT',
  PREPARE_DIALOG: 'PREPARE_DIALOG',
  PREPARE_FOR_EDIT: 'PREPARE_FOR_EDIT',
  SET_EVENT_DESCRIPTION: 'SET_EVENT_DESCRIPTION',
  SET_EVENT_DESCRIPTION_ERROR: 'SET_EVENT_DESCRIPTION_ERROR',
  SET_PRISTINE_STATE: 'SET_PRISITNE_STATE',
  SET_NAME_TOUCHED: 'SET_NAME_TOUCHED',
  SET_EVENT_TITLE: 'SET_EVENT_TITLE',
  SET_SAVING_DATA: 'SET_SAVING_DATA',
};

export const dialogReducer = (
  state: DialogState,
  action: { type: string; payload?: any }
): DialogState => {
  switch (action.type) {
    case dialogActionTypes.SETUP_NEW_EVENT: {
      return { ...state, event: action.payload };
    }
    case dialogActionTypes.PREPARE_DIALOG: {
      const { title, eventDescriptionWithMarkup } = action.payload;

      return {
        ...state,
        eventTitle: '',
        dialogTitle: title,
        eventDescriptionWithMarkup,
        descriptionResetKey: state.descriptionResetKey + 1,
      };
    }
    case dialogActionTypes.PREPARE_FOR_EDIT: {
      const { title, event, documents, eventDescriptionWithMarkup } =
        action.payload;

      return {
        ...state,
        event,
        documents,
        eventDescriptionWithMarkup,
        descriptionResetKey: state.descriptionResetKey + 1,
        dialogTitle: title,
      };
    }
    case dialogActionTypes.SET_PRISTINE_STATE: {
      return { ...state, datePristine: action.payload };
    }
    case dialogActionTypes.SET_NAME_TOUCHED: {
      return { ...state, nameTouched: action.payload };
    }
    case dialogActionTypes.SET_EVENT_TITLE: {
      const eventTitle = action.payload;

      return { ...state, eventTitle, charCount: eventTitle?.length ?? 0 };
    }
    case dialogActionTypes.SET_EVENT_DESCRIPTION: {
      return { ...state, eventDescriptionWithMarkup: action.payload };
    }
    case dialogActionTypes.SET_EVENT_DESCRIPTION_ERROR: {
      return { ...state, descriptionError: action.payload };
    }
    case dialogActionTypes.SET_SAVING_DATA: {
      return { ...state, savingData: action.payload };
    }
    default: {
      const errorMessage = `EventDialog - unsupported action type: ${action.type}`;
      logError(errorMessage);

      throw new Error(errorMessage);
    }
  }
};
